<template>
	<div class="mx-2 w-40">
		<h2>Roster</h2>
		<div
			v-for="(data, id) in current_user_players"
			:key="id"
			class="player-card"
		>
			<div class="player-name">{{ data.player.name }}</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters(['current_user_players']),
	},
};
</script>

<style scoped>
.player-card {
	@apply mb-3;
}

h2 {
	@apply uppercase font-bold text-xl text-center;
}
</style>
